import { IPricingData } from '@models/IPricingData';

interface Props {
  readonly copyTaxLabel: string;
  readonly ecoTaxLabel: string;
  readonly pricingData: IPricingData;
  readonly regionalTaxLabel: string;
  readonly dataTestId?: string;
}

const ProductDetailsPricing = ({
  copyTaxLabel,
  ecoTaxLabel,
  pricingData,
  regionalTaxLabel,
  dataTestId = 'Product-Details-Pricing',
}: Props) => {
  const {
    amountSaved,
    formattedPrice,
    formattedCalculatedPrice,
    ecoTax,
    formattedEcoTax,
    copyTax,
    formattedCopyTax,
  } = pricingData;

  return (
    <div
      className="flex flex-col gap-y-[5px] lg:gap-y-2.5"
      data-testid={dataTestId}
    >
      <div className="flex flex-wrap-reverse items-start gap-x-2.5 lg:gap-x-5">
        {formattedCalculatedPrice && (
          <p
            className="h4 text-black-100"
            data-testid={`${dataTestId}-Formatted-Calculated-Price`}
          >
            {formattedCalculatedPrice}
          </p>
        )}

        {amountSaved > 0 && formattedPrice && (
          <span
            className="h6 pb-0.5 text-grey-450 line-through 2xl:pb-1"
            data-testid={`${dataTestId}-Formatted-Price`}
          >
            {formattedPrice}
          </span>
        )}
      </div>

      <span
        className="body-three text-grey-450"
        data-testid={`${dataTestId}-Tax-Label`}
      >
        {(ecoTax > 0 && ecoTaxLabel.replace('{0}', formattedEcoTax)) ||
          (copyTax > 0 && copyTaxLabel.replace('{0}', formattedCopyTax)) ||
          regionalTaxLabel}
      </span>
    </div>
  );
};

export default ProductDetailsPricing;
